module.exports = __webpack_public_path__ + "img/building-blue.95ef2f22.svg";